import React from 'react';
import '../styles/components/ServiceProcess.scss';

const ServiceProcess = () => {
  const processSteps = [
    {
      step: '01',
      title: 'Consultation & Discovery',
      description: 'We begin by understanding your unique challenges, goals, and organizational context through in-depth discussions.',
      icon: 'fas fa-comments'
    },
    {
      step: '02',
      title: 'Analysis & Planning',
      description: 'Our experts conduct comprehensive analysis and develop tailored strategies aligned with your objectives.',
      icon: 'fas fa-chart-bar'
    },
    {
      step: '03',
      title: 'Implementation',
      description: 'We execute the planned strategies with precision, ensuring minimal disruption to your operations.',
      icon: 'fas fa-cogs'
    },
    {
      step: '04',
      title: 'Monitoring & Evaluation',
      description: 'Continuous monitoring and evaluation to measure impact and make necessary adjustments.',
      icon: 'fas fa-clipboard-check'
    },
    {
      step: '05',
      title: 'Reporting & Review',
      description: 'Comprehensive reporting and review sessions to ensure transparency and continuous improvement.',
      icon: 'fas fa-file-alt'
    }
  ];

  const whyChooseUsPoints = [
    {
      title: 'Expertise You Can Trust',
      description: 'Our team brings years of experience and proven expertise across various sectors and industries.',
      icon: 'fas fa-user-tie'
    },
    {
      title: 'Innovative Thinking',
      description: 'We embrace cutting-edge approaches and creative solutions to address complex challenges.',
      icon: 'fas fa-lightbulb'
    },
    {
      title: 'Tailored Solutions',
      description: 'Every solution is customized to meet your specific needs and organizational context.',
      icon: 'fas fa-puzzle-piece'
    },
    {
      title: 'Client-Centered Approach',
      description: 'Your success is our priority. We work collaboratively to achieve your desired outcomes.',
      icon: 'fas fa-handshake'
    },
    {
      title: 'Commitment to Quality',
      description: 'We maintain the highest standards of quality and excellence in all our deliverables.',
      icon: 'fas fa-award'
    }
  ];

  return (
    <>
      <section className="service-process">
        <div className="container">
          <h2 className="section-title">Our Service Process</h2>
          <p className="section-subtitle">
            We follow a structured approach to ensure successful project delivery and maximum client satisfaction.
          </p>
          <div className="process-steps">
            {processSteps.map((step, index) => (
              <div key={index} className="process-step">
                <div className="step-number">{step.step}</div>
                <div className="step-content">
                  <div className="step-icon">
                    <i className={step.icon}></i>
                  </div>
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-us">
        <div 
          className="why-choose-bg"
          style={{
            backgroundImage: `linear-gradient(rgba(26, 54, 93, 0.85), rgba(26, 54, 93, 0.9)), url('/images/whychoose.jpg')`
          }}
        >
          <div className="container">
            <div className="why-choose-content">
              <div className="why-choose-text">
                <h2>Why Choose Dythel Consulting</h2>
                <p className="intro-text">
                  At Dythel Consulting, we are dedicated to providing exceptional consultancy 
                  services that are rooted in integrity, expertise, and innovation. Choose 
                  Dythel Consulting, where expertise meets excellence, and your success is 
                  our priority.
                </p>
                
                <div className="why-choose-grid">
                  {whyChooseUsPoints.map((point, index) => (
                    <div key={index} className="why-choose-card">
                      <div className="card-icon">
                        <i className={point.icon}></i>
                      </div>
                      <div className="card-content">
                        <h3>{point.title}</h3>
                        <p>{point.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServiceProcess;